import { IAPIRoutes } from "../../../../config";

// Type definitions for the API interfaces
export interface IGetSinglePatientInfoAPI {
  (params: { patient_id: string | number }): Promise<any>;
}

export interface IGetPatientGraphDataAPI {
  (params: { patient_id: string | number }): Promise<any>;
}

type IHHDevice = {
  id: string;
  device_type: string;
  device_id: string;
  asn_from: string;
  asn_to: string | null;
};

type IHHPatient = {
  _id: string;
  first_name: string;
  last_name: string;
  username: string;
  devices: IHHDevice[];
  signal_id: string;
  facility_id: number;
};

type IHHPatientsList = IHHPatient[];

export interface IGetSelectedFacilityPatientListAPI {
  (params: { clinic_id: string | number }): Promise<IHHPatientsList>;
}

export type IHomeHealthRepository = ReturnType<
  typeof HomeHealthRepositoryFactory
>;

export const HomeHealthRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET } = APIProvider;
  const { getAuthenticationAccessToken } = AuthService;

  const getSinglePatientInfo: IGetSinglePatientInfoAPI = async ({
    patient_id,
  }) =>
    GET(
      APIRoutes.apiGetSinglePatientInfo.replace(
        "{patient_id}",
        patient_id?.toString()
      ),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationAccessToken()}`,
      }
    );

  const getPatientGraphData: IGetPatientGraphDataAPI = async ({ patient_id }) =>
    GET(
      APIRoutes.apiGetPatientGraphData.replace(
        "{patient_id}",
        patient_id?.toString()
      ),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationAccessToken()}`,
      }
    );

  const getSelectedFacilityPatientList: IGetSelectedFacilityPatientListAPI =
    async ({ clinic_id }) =>
      GET(
        APIRoutes.apiGetSelectedFacilityPatientList.replace(
          "{clinic_id}",
          clinic_id?.toString()
        ),
        {},
        {
          Authorization: `Bearer ${await getAuthenticationAccessToken()}`,
        }
      );

  return {
    getSinglePatientInfo,
    getPatientGraphData,
    getSelectedFacilityPatientList,
  };
};
